import { Injectable, signal } from '@angular/core';
import { MatSnackBar, MatSnackBarConfig } from '@angular/material/snack-bar';

type SnackbarType = 'success' | 'error' | 'warning' | 'info';

@Injectable({
  providedIn: 'root',
})
export class SnackbarService {
  private defaultConfig = signal<MatSnackBarConfig>({
    duration: 3000,
    horizontalPosition: 'center',
    verticalPosition: 'bottom',
  });

  private snackbarConfigs = signal<Record<SnackbarType, MatSnackBarConfig>>({
    success: {
      ...this.defaultConfig(),
      panelClass: ['snackbar-success'],
    },
    error: {
      ...this.defaultConfig(),
      panelClass: ['snackbar-error'],
    },
    warning: {
      ...this.defaultConfig(),
      panelClass: ['snackbar-warning'],
    },
    info: {
      ...this.defaultConfig(),
      panelClass: ['snackbar-info'],
    },
  });

  constructor(private snackBar: MatSnackBar) {}

  success(message: string, duration: number = 3000, action: string = 'X'): void {
    this.snackBar.open(message, action, {
      ...this.snackbarConfigs().success,
      duration,
    });
  }

  error(message: string, duration: number = 3000, action: string = 'X'): void {
    this.snackBar.open(message, action, {
      ...this.snackbarConfigs().error,
      duration,
    });
  }

  warning(message: string, duration: number = 3000, action: string = 'X'): void {
    this.snackBar.open(message, action, {
      ...this.snackbarConfigs().warning,
      duration,
    });
  }

  info(message: string, duration: number = 3000, action: string = 'X'): void {
    this.snackBar.open(message, action, {
      ...this.snackbarConfigs().info,
      duration,
    });
  }

  show(message: string, action: string = 'X', config?: MatSnackBarConfig): void {
    this.snackBar.open(message, action, { ...this.defaultConfig(), ...config });
  }
}
